import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getActiveWaitersList } from '../utils/transformer';

import { api } from './Api';
import type { BookingWaitInfo } from './types';

export interface CourtsBookingState {
  activeBookingWaitTime: string | null;
  activeBookingsWaitId: number[] | null;
  bookingsWait: BookingWaitInfo[] | null;
}

const initialState: CourtsBookingState = {
  activeBookingsWaitId: null,
  activeBookingWaitTime: null,
  bookingsWait: null
};

const bookingWaitSlice = createSlice({
  name: 'bookingWait',
  initialState,
  reducers: {
    changeActiveBookingWaitTime: (state, action: PayloadAction<string | null>) => {
      state.activeBookingWaitTime = action.payload;
    },
    changeActiveBookingsWaitId: (state, action: PayloadAction<number[] | null>) => {
      state.activeBookingsWaitId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        api.endpoints.getWaitingList.matchFulfilled,
        (state, action) => {
          state.bookingsWait = getActiveWaitersList(action.payload);
        },
      );
  },
});

export const selectBookingWaitTime = (state: RootState) => state.bookingWait.activeBookingWaitTime;
export const selectBookingsWait = (state: RootState) => state.bookingWait.bookingsWait;
export const selectActiveBookingsWaitId = (state: RootState) => state.bookingWait.activeBookingsWaitId;

export const { changeActiveBookingWaitTime, changeActiveBookingsWaitId } = bookingWaitSlice.actions;
export { bookingWaitSlice };
